import compose from 'recompose/compose';
import formatPrismicData from '../../hocs/formatPrismicData';
import HelpContentModules from './HelpContentModules';
import { withProps } from 'recompose';
import get from 'lodash/get';

const enhance = compose(
  formatPrismicData,
  withProps(props => ({
    helpContentModules: get(props, 'content.helpContentModules') || []
  }))
);

export default enhance(HelpContentModules);



// WEBPACK FOOTER //
// ./src/client/js/view/components/HelpContentModules/index.js